import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, BaseRequestOptions } from '@angular/http';
import { UserTO, NotificationTO, ResultMessage, CommaonUserTO } from '../model/notificationTO'
import { catchError, retry,map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import * as CryptoJS from "crypto-js";
import { Observable,ErrorObserver} from 'rxjs';
export const gnGetAllActiveAlertList = "Notify/GetAllActiveAlertList?userId=";
export const gnPostAlertAcknowledgement = "Notify/PostAlertAcknowledgement";
export const gnPostResetAllAlerts = "Notify/PostResetAllAlerts";

@Injectable()
export class NotificationServices {
    constructor(private http: Http) { }
    userTO: CommaonUserTO = {}
    resultMessage: ResultMessage = new ResultMessage;
    getUserTOFromLocalStorage(): CommaonUserTO {
        let userTo: CommaonUserTO = {};
        userTo = JSON.parse(this.decryption(localStorage.getItem("currentUser")));
        if (userTo == undefined || userTo == null) {

        } else {
        }
        return userTo;
    }
    getAlertForNotify(Url) {
        debugger
        if (this.userTO == null && this.userTO == undefined) {
            return;
        }
        this.getAllActiveNotification(this.userTO,Url).subscribe(
            res => {
                var v = res.filter(p => p.IsAcknowledged == 0).length;
                if (document.getElementById("bgNotification") != null) {
                    document.getElementById("bgNotification").innerText = v == 0 ? '' : v.toString();
                }
            },
            err => { }
        )

    }
    getAllActiveNotification(UserTo: CommaonUserTO,masterBaseUrl:string): Observable<NotificationTO[]> {
        //let keys = "https://simplydeliverdemo.vegainnovations.co.in/madhavsimplideliverapi/api/Notify/GetAllActiveAlertList?userId=1&roleId=1"
        //let keys = masterBaseUrl + gnGetAllActiveAlertList + UserTo.IdUser + "&roleId=" + UserTo.UserRoleList[0].RoleId
        let keys = masterBaseUrl + "Notify/GetAllActiveAlertList?userId=1&roleId=1";
        return this.http
            .get(keys).pipe(map((response: any) => response.json()));
    }

    postAlertAcknowledgement(notificationTo: NotificationTO
        , loginId: number,URL:string) {
        var params = {
            alertUsersTO: notificationTo,
            loginUserId: loginId
        };
        let bodyString = JSON.stringify(params);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.http.post(URL + gnPostAlertAcknowledgement, bodyString, options);
    }

    postAllAlertAcknowledgement(userTo: CommaonUserTO,URL:string) {
        var params = {
            loginUserId: userTo.IdUser,
            roleId: userTo.UserRoleList[0].RoleId
        };
        let bodyString = JSON.stringify(params);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        
        return this.http.post(URL + gnPostResetAllAlerts, bodyString, options);
    }

    encryption(data) {
        data = JSON.stringify(data);
        // Encrypt
        var ciphertext = CryptoJS.AES.encrypt(data.toString(), "secret key 123");
        return ciphertext.toString();
    }
    decryption(data) {
        // Decrypt
        if (data) {
            var bytes = CryptoJS.AES.decrypt(data, "secret key 123");
            var plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return plaintext;
        }
        return null;
    }
}